import { Injectable } from '@angular/core';
import { LabTestCategoryModel } from '../../../models/master-data/labtest-category.model';
import {BaseService} from '../../../shared/services/base.service';
import {LabTestCategoryUrl} from  '../../../shared/urls/master-data.labtest-category.url';
@Injectable()
export class LabTestCategoryService {
    constructor(public baseService : BaseService) {
    }

    getLabTestCategoryList(param){
        const url = LabTestCategoryUrl.LABTESTCATEGORY_GET;
        return this.baseService.getData(url,param);
    }

    getLabTestCategoryById(Id){
        const url = LabTestCategoryUrl.LABTESTCATEGORY_GET_DETAIL + `${Id}`;
        return this.baseService.getById(url, Id);
    }

    updateLabTest(id, param){
        const url = LabTestCategoryUrl.LABTESTCATEGORY_UPDATE.replace('{id}', id);
        return this.baseService.update(url, param);
    }

    createLabTestCategory(param)
    {
        const url = LabTestCategoryUrl.LABTESTCATEGORY_ADD;
        return this.baseService.post(url, param);
    }

    removeLabTestCategory(id)
    {
        const url = LabTestCategoryUrl.LABTESTCATEGORY_DELETE.replace('{id}', id);
        return this.baseService.delete(url);
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/labtest-category/labtest-category.service.ts